import { render, staticRenderFns } from "./PreviewAttachment.vue?vue&type=template&id=23aaa4fd"
import script from "./PreviewAttachment.vue?vue&type=script&lang=js"
export * from "./PreviewAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports